module.exports = function() {
  return new Worker(__webpack_public_path__ + "5c396b62ef5b582516e8.worker.js");
};